import { Box } from '@bechtel/gds';
import { Formik } from 'formik';
import RenameTagsForm from './form';
import { renameTagsInitialValues } from './types';

const RenameTags = () => {
  return (
    <Box flexGrow={{ sm: ' 1' }} flexDirection={{ sm: 'column' }}>
      <Formik
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={renameTagsInitialValues}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(false);
        }}
      >
        <RenameTagsForm />
      </Formik>
    </Box>
  );
};

export default RenameTags;
